module.exports = __webpack_public_path__ + "static/bundle-team-8425037c51091c7531f0e3adbfe8c1bb.png";